angular.module('wbDashboard').controller('PlansInfoControllerAurea',
        ['$scope', '$uibModal', '$q', '$timeout', 'User', 'Track', 'PlanService', 'DataService', 'Message',
function ($scope, $uibModal, $q, $timeout, User, Track, PlanService, DataService, Message) {
    $scope.tabs = {
        active: "features",
        data: {
            "features" : {label: "Features", value: "features", callbacks: {} },
            "eligibility" : {label: "Eligibility", value: "eligibility", callbacks: {} },
            "pricing" : {label: "Pricing", value: "pricing", callbacks: {} }
        }
    };
    var redirectRoute = 'base.plans.detail.plan';
    var init = false;
    var modalInstance;

    if ($scope.$stateParams.pslug === "portfolioplus") {
        DataService.retrieveAssetClasses();
        $scope.$watch(function () {
            return DataService.getAssetClasses();
        }, function (assets) {
            if (assets) {
                $scope.assets = assets;
            }
        });


        $scope.filterInvestments = function(a) {
            if (a.code === "REIT" && a.sector.code === "consumer") {
                return false;
            }
            return true;
        };

        $scope.filterCore = function(a) {
            if (a.code === "REIT") return true;
            if (a.code === "MUNI") return false;
            return ['global', 'bonds'].indexOf(a.sector.code) > -1;
        };

        $scope.slickConfigAssets = {
            dots: false,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 818,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 530,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        };

    }

    $scope.$watch(function() { return $scope.PS.getPlan($scope.$stateParams.pslug); }, function(plan) {
        if (plan) {
            $scope.plan = plan;
            if (plan.slug === "portfolioplus") {
                $scope.tabs.data.eligibility.label = "Investments";
            }

            if (plan.enabled) {
                if (!$scope.$stateParams.fslug || init) {
                    $scope.$state.go(redirectRoute, {pslug: $scope.$stateParams.pslug, fslug: $scope.$stateParams.fslug, init: init}, {location: 'replace'});
                } else {
                    $scope.$state.go(redirectRoute + ".feature.detail", {pslug: $scope.$stateParams.pslug, fslug: $scope.$stateParams.fslug}, {location: 'replace'});
                }
            }
        }
    });

    $scope.enablePlan = function(plan) {
        $scope.pageData.sending = true;
        let data = {
            slug: plan.slug,
            plan_name: plan.name,
            estimated_cost: plan.billing.estimated_monthly_cost,
            end_date: plan.end_date,
            trial_end_date: plan.trial_end_date
        };
        return PlanService.user.addPlan(data).catch(function(response) {
            Message.set({
                text: "Error enabling " + plan.name,
                type: "warning"
            });
            throw response;
        }).then(function(newPlan) {
            var msg;
            switch (plan.slug) {
                case 'taxplan':
                    msg = plan.display_name + " Activated: Sorry tax man...";
                    break;
                case 'fastmoney':
                    msg = plan.display_name + " Activated: You're on the fast track.";
                    break;
                case 'portfolioplus':
                    msg = plan.display_name + " Activated.";
                    break;
            }
            Message.set({
                text: msg,
                type: "success"
            });
            Track.send("Package Activated", "Services", {plan: plan.name});
            return PlanService.retrievePlans(true);
        }).finally(function() {
            //will be redirected by userPlan watcher
            redirectRoute = "base.plans.detail.plan.init";
            init = true;
            $scope.pageData.sending = false;
        });
    };

    $scope.confirmModal = function() {

        $q.when(1).then(function() {
            modalInstance = $uibModal.open({
                templateUrl: "plans.info.enable.modal.tpl.html",
                size: 'md',
                scope: $scope,
                windowClass: 'plan-info-confirm-modal'
            });

            return modalInstance.result.then(function (plan) {
                if (plan) {
                    return $scope.enablePlan(plan);
                }
            }).catch(function() {
                //dismissed/cancelled
                if (!$scope.$state.transition && $scope.$state.current.name === 'base.plans.info.enable') {
                    //make sure no transition has already started
                    $scope.$state.go('^', {}, {location: 'replace'});
                }
            }).finally(function () {
            });
        }).catch(angular.noop).finally(function() {
            $scope.pageData.sending = false;
        });

    };

    var transitionDeregisterHook = {};
    transitionDeregisterHook[0] = $scope.$transitions.onSuccess({ to: 'base.plans.info.enable' }, function(trans) {
        if (trans.$from().name !== trans.$to().name) {
            $scope.confirmModal();
        }
    });
    transitionDeregisterHook[1] = $scope.$transitions.onSuccess({ from: 'base.plans.info.enable' }, function(trans) {
        if (modalInstance && trans.$from().name !== trans.$to().name) {
            modalInstance.dismiss();
        }
    });
    if ($scope.$state.includes('**.enable')) {
        $timeout(function() {
            //need to give time for the overview watcher to finish
            //and make sure it hasn't navigated away
            if ($scope.$state.includes('**.enable')) {
                $scope.confirmModal();
            }
        });
    }

    $scope.$on('$destroy', function() {
        if (transitionDeregisterHook[0]) {
            transitionDeregisterHook[0]();
        }
        if (transitionDeregisterHook[1]) {
            transitionDeregisterHook[1]();
        }
    });




    /**
     * For eligibility
     */

    $scope.eligibility = {
        taxableIncome : false,
        autoDeposit: false,
        taxableAccount: false,
        taxablePIAAccount: false,
    };
    $scope.$watch('overview', function(overview) {
        if (overview) {
            if (overview.user.annual_income > 9226) {
                $scope.eligibility.taxableIncome = true;
            }
            if (overview.combined_auto_deposits > 0) {
                $scope.eligibility.autoDeposit = true;
            }

            angular.forEach(overview.account_overview, function(account) {
                if (!account.is_ira && account.type !== 'UTMA') {
                    $scope.eligibility.taxableAccount = true;
                    if (account.type === "personal-investment-account") {
                        $scope.eligibility.taxablePIAAccount = true;
                    }
                }
            });
        }
    });





}]);
